import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Import JSON with explicit type assertion for TypeScript 5 compatibility
import esTranslations from './locales/es.json';
import enTranslations from './locales/en.json';

const resources = {
  es: { 
    translation: esTranslations as Record<string, unknown>
  },
  en: { 
    translation: enTranslations as Record<string, unknown>
  },
};

// Initialize i18n - ensure it completes before app renders
if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: 'es', // Default language
      fallbackLng: 'es',
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: false,
      },
      debug: process.env.NODE_ENV === 'development',
    })
    .catch((error: Error) => {
      console.error('Failed to initialize i18n:', error);
      // Fallback initialization to prevent blank page
      i18n.init({
        resources: { 
          es: { translation: {} }, 
          en: { translation: {} } 
        },
        lng: 'es',
        fallbackLng: 'es',
        interpolation: {
          escapeValue: false,
        },
        react: {
          useSuspense: false,
        },
      });
    });
}

export default i18n;
